import React, { useRef } from 'react';
import Overlay, { OverlayProps } from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';

export function FormEngineButtonElementBasePopover({
    target,
    show = false,
    placement = 'bottom',
    title,
    children,
}: {
    show?: boolean;
    placement?: OverlayProps['placement'];
    title?: React.ReactNode;
    children?: React.ReactNode;
    target?: OverlayProps['target'];
}) {
    const containerRef = useRef<HTMLDivElement>(null);

    if (!target) {
        return null;
    }

    return (
        <div ref={containerRef} className="fe-button-popover-container">
            <Overlay
                show={show}
                target={target}
                placement={placement}
                container={containerRef}
            >
                <Popover id={`popover-positioned-${placement}`}>
                    {title && <Popover.Header as="h3">{title}</Popover.Header>}
                    {children && <Popover.Body>{children}</Popover.Body>}
                </Popover>
            </Overlay>
        </div>
    );
}
